import React, { FC } from 'react'
import { CombinedImageItem } from '../types'

interface ImageGalleryProps {
  images: CombinedImageItem[]
  selectedImage: CombinedImageItem | null
  onSelectImage: (image: CombinedImageItem) => void
  loading: boolean
}

/**
 * Galeria de Imagens do Produto + Variações
 */
export const ImageGallery: FC<ImageGalleryProps> = ({
  images,
  selectedImage,
  onSelectImage,
  loading,
}) => {
  if (loading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Carregando...</span>
        </div>
        <p className='mt-2'>Carregando imagens...</p>
      </div>
    )
  }

  if (images.length === 0) {
    return (
      <div className='alert alert-info'>
        <i className='bi bi-info-circle me-2'></i>
        Nenhuma imagem disponível para este produto
      </div>
    )
  }

  return (
    <div className='row row-cols-auto g-3'>
      {images.map((image) => (
        <div key={image.id} className='col'>
          <div
            className={`card cursor-pointer transition-all h-100 ${
              selectedImage?.id === image.id ? 'border-primary border-2' : ''
            }`}
            style={{
              maxWidth: '180px',
              cursor: 'pointer',
              borderWidth: selectedImage?.id === image.id ? '2px' : '1px',
            }}
            onClick={() => onSelectImage(image)}
          >
            {/* IMAGEM */}
            <img
              src={image.imageUrl}
              alt={image.label}
              className='card-img-top'
              style={{
                height: '150px',
                objectFit: 'cover',
              }}
              onError={(e) => {
                ;(e.target as HTMLImageElement).src = 'https://placehold.co/150x150?text=Erro'
              }}
            />

            {/* LABEL */}
            <div className='card-body p-2'>
              <small className='text-muted d-block text-truncate'>
                {image.type === 'product-image' ? '📦' : '📋'} {image.label}
              </small>
              {image.sku && (
                <small className='text-primary fw-bold d-block text-truncate'>
                  SKU: {image.sku}
                </small>
              )}
            </div>

            {/* SELEÇÃO */}
            {selectedImage?.id === image.id && (
              <div className='position-absolute top-0 end-0 p-2'>
                <span className='badge bg-primary'>
                  <i className='bi bi-check-lg'></i>
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
